import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import Indicator from '../../store/utils/Indicator';
import { Icon, Spinner } from '../display';
import classes from './SavingIndicator.module.scss';

export default observer(function SavingIndicator({
  indicator,
  className,
  component = Box,
  ...rest
}: SavingIndicatorProps) {
  const styledClassName = classes[indicator.state];

  let content: ReactNode;

  switch (indicator.state) {
    case 'error': {
      content = (
        <>
          <Icon icon="exclamation-circle" />
          {indicator.error}
        </>
      );
      break;
    }

    case 'processed': {
      content = (
        <>
          <Icon icon="check" size="small" />
          saved
        </>
      );
      break;
    }

    case 'processing': {
      content = (
        <>
          <Spinner />
          saving
        </>
      );
      break;
    }

    default: {
      content = '';
    }
  }

  const Component = component;

  return (
    <Component className={clsx(styledClassName, className)} {...rest}>
      {content}
    </Component>
  );
});

export interface SavingIndicatorProps extends BoxProps {
  indicator: Indicator;
}
